import { render, staticRenderFns } from "./UserActivityBarSettings.vue?vue&type=template&id=c756d3f2&"
import script from "./UserActivityBarSettings.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserActivityBarSettings.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports